<section class="fullWidthCls admPageSec marginAtTop">

  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
            <img src="./assets/images/Location_Setting_Icon.png" alt="" />
          <!-- <i class="material-icons cusIconSize">&#xE8B4;</i> -->
          <span>Location Settings</span>
        </p>
      </div>

      <form class="example-form" [formGroup]="form" novalidate>
        <md-card class="paddingTopCls">
          <md-card-content>
            <div class="col s12 m4 l4" *ngIf="pageConfig.showField">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Select Region" mdInput formControlName="regionId" [mdAutocomplete]="region" [showDropDown]="{model: 'region', scope : this }">
                  <md-autocomplete #region="mdAutocomplete" [displayWith]="displayFn">
                    <md-option *ngFor="let option of (regionFilteredOptions | async)" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.regionId.touched && form.controls.regionId.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Select Location" mdInput formControlName="id" [mdAutocomplete]="location" [showDropDown]="{model: 'location', scope : this }">
                  <md-autocomplete #location="mdAutocomplete" [displayWith]="displayFn">
                    <md-option *ngFor="let option of locationFilteredOptions | async" [value]="option" class="subOptionShow">
                      <span>
                        {{ option.name }}
                        <span title="{{ option.locationAddress }}" class="locationListAddressCls">
                          <br/>{{ option.locationAddress }}</span>
                      </span>
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.id.touched && form.controls.id.invalid"></p>
              </div>
            </div>

          </md-card-content>

        </md-card>

        <!-- second card Location settings details -->

        <md-card class="setting-card" *ngIf="locationId != 0">
          <md-card-content>
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Location Details</span>
                </p>
              </div>
            </md-card-title>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Location Name" formControlName="locationName" maxlength="100">
                </md-form-field>
                <p requiredField *ngIf=" form.controls.locationName.touched && form.controls.locationName.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Location Address" formControlName="address1" maxlength="200">
                </md-form-field>
                <p requiredField *ngIf=" form.controls.address1.touched && form.controls.address1.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Street 2" formControlName="address2" maxlength="200">
                </md-form-field>
                <p requiredField *ngIf=" form.controls.address2.touched && form.controls.address2.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="Country" mdInput formControlName="countryId" [mdAutocomplete]="country">
                  <md-autocomplete #country="mdAutocomplete" [displayWith]="displayFn">
                    <md-option *ngFor="let option of countryFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.countryId.touched && form.controls.countryId.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="State" mdInput formControlName="stateId" [mdAutocomplete]="state">
                  <md-autocomplete #state="mdAutocomplete" [displayWith]="displayFn">
                    <md-option *ngFor="let option of stateFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.stateId.touched && form.controls.stateId.invalid"></p>
              </div>

            </div>
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input type="text" placeholder="City" mdInput formControlName="cityId" [mdAutocomplete]="city">
                  <md-autocomplete #city="mdAutocomplete" [displayWith]="displayFn">
                    <md-option *ngFor="let option of cityFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf=" form.controls.cityId.touched && form.controls.cityId.invalid"></p>
              </div>

            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Zip" formControlName="zipcode" maxlength="10">
                </md-form-field>
                <p requiredField *ngIf=" form.controls.zipcode.touched && form.controls.zipcode.invalid"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div class="errorZoneSec">

                <md-form-field class="example-full-width">
                  <input type="text" placeholder="keyboard Type" mdInput formControlName="keyboardTypeId" [mdAutocomplete]="keyboardType" maxlength="200">

                  <md-autocomplete #keyboardType="mdAutocomplete" [displayWith]="displayFn">
                    <md-option *ngFor="let option of keyboardTypeFilteredOptions | async" [value]="option">
                      {{ option.name }}
                    </md-option>
                  </md-autocomplete>
                </md-form-field>
                <p requiredField *ngIf="form.controls.keyboardTypeId.touched && form.controls.keyboardTypeId.invalid;"></p>
              </div>
            </div>

            <div class="col s12 m4 l4">
              <div>
                <md-form-field class="example-full-width">
                  <input mdInput placeholder="Time Zone" formControlName="timezone" [readonly]="true">
                </md-form-field>
              </div>
            </div>

            <div *ngIf="locationDetails && locationDetails.candidateInstructions" class="col s12 m12 l12">
              <div class="errorZoneSec">
                <p><strong>Instructions To Candidate</strong></p>
                <p>These instructions are sent to the candidate when they schedule or reschedule their exam.</p>
                <pre style="width: 100%;">{{locationDetails.candidateInstructions}}</pre>
              </div>
            </div>

          </md-card-content>
        </md-card>
        <!-- hours panel -->
        <md-card class="setting-card" *ngIf="locationId != 0">
          <md-card-content>
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Available Exam Hours For Location</span>
                </p>
              </div>
            </md-card-title>

            <div formArrayName="locationCalendarList">
              <ul class="examHoursListSec">
                <li *ngFor="let item of days; let i=index" [ngClass]="{'unavailableList': form.controls.locationCalendarList.controls[i].controls.status.value == 'CLOSE' }">
                  <div [formGroupName]="i">
                    <span [ngClass]="{'unavailable-day': form.controls.locationCalendarList.controls[i].controls.status.value == 'CLOSE', 'available-day': form.controls.locationCalendarList.controls[i].controls.status.value == 'OPEN'}">{{item}}</span>
                    <div *ngIf="form.controls.locationCalendarList.controls[i].controls.status.value == 'CLOSE'">
                      <span style="background-color: #c3c0c0;">Unavailable</span>
                    </div>
                    <div class="errorZoneSec" *ngIf="form.controls.locationCalendarList.controls[i].controls.status.value == 'OPEN'">
                      <custom-time-control formControlName="startTime" [defaultTime]="defaultStartTime" (ngModelChange)="onTimeChange($event, form.controls.locationCalendarList.controls[i].controls.endTime.value, i)"></custom-time-control>
                      <!-- <md-form-field class="example-full-width">
                        <i class="material-icons">&#xE192;</i>
                        <input mdInput type="time" formControlName="startTime" (ngModelChange)="onTimeChange($event, form.controls.locationCalendarList.controls[i].controls.endTime.value, i)">
                      </md-form-field> -->
                      <span>to</span>
                      <custom-time-control formControlName="endTime" [defaultTime]="defaultEndTime" (ngModelChange)="onTimeChange(form.controls.locationCalendarList.controls[i].controls.startTime.value, $event, i)"></custom-time-control>
                      <!-- <md-form-field class="example-full-width">
                        <i class="material-icons">&#xE192;</i>
                        <input mdInput type="time" formControlName="endTime" (ngModelChange)="onTimeChange(form.controls.locationCalendarList.controls[i].controls.startTime.value, $event, i)">
                      </md-form-field> -->
                      <p requiredField *ngIf="(form.controls.locationCalendarList.controls[i].controls.startTime.touched && form.controls.locationCalendarList.controls[i].controls.startTime.invalid) || (form.controls.locationCalendarList.controls[i].controls.endTime.touched && form.controls.locationCalendarList.controls[i].controls.endTime.invalid)"></p>
                      <p class="validate" *ngIf="pageConfig.showTimeError[i]">End Time should be greater than start Time</p>
                    </div>

                    <md-select formControlName="status" (change)="onStatusChange($event, i)">
                      <md-option *ngFor="let status of weekStatus" [value]="status">
                        {{ status }}
                      </md-option>
                    </md-select>
                  </div>
                </li>
              </ul>
            </div>

          </md-card-content>
        </md-card>
        <div class="button-row setting-btn">
          <button *ngIf="locationId != 0" [disabled]="pageConfig.isUpdateBtnDisable || form.invalid || pageConfig.invalidTime"
            md-raised-button class="glbAdminBtnCls1" type="submit" (click)="onUpdateLocationSetting()">UPDATE</button>
          <ng-container *ngIf="locationId != 0">
            <button *ngIf="pageConfig.showField" [disabled]="locationId == 0" md-raised-button class="glbAdminBtnCls1" type="submit"
              (click)="onBlackListExam()">BLACKLIST EXAM</button>
          </ng-container>

        </div>
      </form>


    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location-setting/adm-manage-location-setting.component.html